import classNames from 'classnames'

interface Props {
  readonly label: string
  /** 0–100; rounded for display. */
  readonly percent: number
  readonly className?: string
}

export default function ProgressBar({ label, percent, className }: Props): JSX.Element {
  const value = Math.round(Math.min(100, Math.max(0, percent)))

  return (
    <div className={classNames('flex w-full flex-col gap-2 text-primaryTextColor', className)}>
      <div className="flex justify-between text-sm">
        <span>{label}</span>
        <span>{value}%</span>
      </div>
      <div
        className="h-2 w-full overflow-hidden rounded-full bg-borderGrey"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
      >
        <div className="h-full rounded-full bg-primaryRed transition-all duration-500" style={{ width: `${value}%` }} />
      </div>
    </div>
  )
}
